import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EpayService } from 'src/app/services/epay.service';
import { environment } from '../../../../environments/environment';
import { ServiceRequest, ServiceRequestClient } from '../../../web-api-client';

@Component({
  selector: 'app-epay-prof-payment',
  templateUrl: './epayProfile-payment.component.html',
  styleUrls: ['./epayProfile-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EPayProfilePaymentComponent {

  response: string | null = null;

  @Input() serviceRequest: ServiceRequest;

  @Input() amount: number;


  constructor(private epayService: EpayService, private readonly srClient: ServiceRequestClient) { }

  submitPayment(form: NgForm): void {

    this.srClient.createEpay(this.serviceRequest).subscribe(r => {



      const data = {
        MIN: environment.easyPayMurchId, // Твой клиентски идентификационен номер
        //EMAIL: 'pminev@axsion.net',
        INVOICE: r.invoiceId,
        AMOUNT: this.amount,
        CURRENCY: 'BGN', // Валутата е фиксирана, може да добавиш поле за избор на валута
        EXP_TIME: r.expirationDate,
        DESCR: r.description,
        ENCODING: 'utf-8'
      };

      const page = form.value.paymentMethod ? form.value.paymentMethod :'paylogin'; // Вземаме избрания метод на плащане

      const baseUrl = window.location.origin; // Взимаме текущия домейн
      const successUrl = `${baseUrl}/success`;
      const cancelUrl = `${baseUrl}/cancel`;


      const paymentUrl = this.epayService.generateEPayProfilePaymentUrl(
        data,
        page, // Динамично подаване на избрания метод на плащане
        'bg', // Език на страницата
        successUrl, // URL_OK
        cancelUrl // URL_CANCEL
      );

      window.location.href = paymentUrl; // Пренасочване към генерирания URL


    });
   
  }


}
